export default [{
  value: 'getActive',
  queueType: 'normal',
  displayName: 'Active'
}, {
  value: 'getWaiting',
  queueType: 'normal',
  displayName: 'Waiting'
}, {
  value: 'getFailed',
  queueType: 'normal',
  displayName: 'Failed'
}, {
  value: 'getCompleted',
  queueType: 'normal',
  displayName: 'Completed'
}, {
  value: 'getActive',
  queueType: 'long',
  displayName: 'Long Active'
}, {
  value: 'getWaiting',
  queueType: 'long',
  displayName: 'Long Waiting'
}, {
  value: 'getFailed',
  queueType: 'long',
  displayName: 'Long Failed'
}, {
  value: 'getCompleted',
  queueType: 'long',
  displayName: 'Long Completed'
}];
